import { JANE_DEFINED_ROWS } from '@iheartjane/menu';

import type { CustomLanguage } from '@jane/bloom/types/schemas/bloom/customLanguage';
import { formatLabel } from '@jane/bloom/utils/strings/formatLabel';

export const bundleSpecialComplianceWord = (
  bundleLabel: string | undefined | null,
  specialLabel: string | undefined | null
) => `Your ${bundleLabel ?? 'bundle'} ${specialLabel ?? 'special'} applies to`;

export const generateCustomLabel = (
  label: string,
  customLanguage: CustomLanguage
) => {
  const customRowDisplayName =
    (customLanguage.productTypeLabels[label.toLowerCase()] ||
      customLanguage.productTypeLabels[label]) ??
    label;
  const customRow = !JANE_DEFINED_ROWS.includes(customRowDisplayName)
    ? customRowDisplayName
    : label;

  if (
    customRow === 'discountableBundleProducts' &&
    customLanguage.storeComplianceLanguageSettings
  )
    return bundleSpecialComplianceWord(
      customLanguage.storeComplianceLanguageSettings['bundle'],
      customLanguage.storeComplianceLanguageSettings['special']
    );

  return formatLabel(customRow);
};
